export default {
  detail: '商户详情',
  backpage: '返回上一页',
  basic: '商户基本信息',
  agency: '代理人',
  merchantkey: '商户密钥',
  indetails: '商户详细信息',
  merchantcode: '商户动态验证码绑定',
  scan: '扫描二维码获取验证码输入',
  authcode: '请输入验证码',
  codenull: '验证码不能为空',
  label: {
    amount: '金额',
    merchatNo: '商户号',
    walletTypeTransferIn: '转入钱包类型',
    walletTypeTransferOut: '转出钱包类型',
    usdt_qr: 'USDT钱包',
    walletTile: '钱包余额详情',
    all: 'all钱包',
    kou: '人工扣款',
    recharge: '人工充值'
  },
  rules: {
    amount: {
      required: '金额不能为空',
      type: '金额必须为数字',
      typeinteger: '金额必须为数字,且必须是整数',
      max: '金额不能大于余额'
    },
    remark: {
      required: '备注不能为空'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/merchantdetails.js